import React, { useEffect, useState } from 'react';
import { Activity } from 'lucide-react';
import { getBytes, subscribeDataMeter, formatBytes } from '@/utils/dataMeter';

// Small chip that shows the approximate data consumed by the app in the current
// session. Only rendered for the teacher (see Layout). Subscribes to the shared
// data-meter store which is fed by the axios interceptor in App.js.
export const DataMeterChip = ({ className = '' }) => {
  const [bytes, setBytes] = useState(getBytes());
  useEffect(() => subscribeDataMeter(setBytes), []);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-slate-50 px-2.5 py-1 text-xs font-medium text-slate-600 ${className}`}
      title="Datos aproximados usados por la app en esta sesión (se reinicia al recargar)"
      data-testid="data-meter-chip"
    >
      <Activity className="w-3.5 h-3.5 text-emerald-500" />
      <span className="tabular-nums" data-testid="data-meter-value">{formatBytes(bytes)}</span>
    </span>
  );
};

export default DataMeterChip;
